export const NavItems = [
    { name: "Dashboard", path: "/dashboard" },
    { name: "Orders", path: "/orders" },
    { name: "Inventory", path: "/inventory" },
    {
        name: "Store Promotions", subItems: [
            { name: "SMS", path: "/sms" },
            // { name: "Coupons" , path: "/coupons" },
        ]
    },
    { name: "Profile", path: "/profile" },
    { name: "Commission structure", path: "/commission" },
]
export const DistributorNavItems = [
    { name: "Orders", path: "/orders" },
    { name: "Inventory", path: "/inventory" },
    { name: "Profile", path: "/profile" },
    { name: "Commission structure", path: "/commission" },
]
export const seller = [
    { name: "Dashboard", path: "/dashboard" },
    { name: "Orders", path: "/orders" },
    { name: "Inventory", path: "/inventory" },
    { name: "Profile", path: "/profile" },
    { name: "Commission structure", path: "/commission" },
    { name: "Margin Upload", path: "/margin-upload" },
]